import React from 'react';
import {ModalWindow} from 'components/ModalWindow';
import {FFButton} from 'ui/FFButton';
import {useL10n} from 'i18n/hooks';
import type {ModalProps} from 'stores/modalStore';
import './style.scss';

/**
 * Figma `pop up` over a Logout pressed offline (useMyLogout): the account stays signed in.
 * `onOk` / `onCancel` are the modal store's, and close the window.
 */
export const LogoutOfflineModal = (props: ModalProps) => {
    const {t} = useL10n();
    return (
        <ModalWindow {...props} width={311} className="logout-offline-modal">
            <div className="logout-offline-modal__content" role="alert" data-testid="logout-offline">
                <div className="logout-offline-modal__head">
                    <div className="logout-offline-modal__title">{t('logout-offline-title')}</div>
                    <p className="logout-offline-modal__body">{t('logout-offline-body')}</p>
                </div>
                <FFButton size="m" block onClick={() => props.onOk?.()}>{t('logout-offline-ok')}</FFButton>
            </div>
        </ModalWindow>
    );
};
